import { LocaleObject, setLocale } from "yup";
import { YupLocaleObject } from "./components/Form/YupLocaleObject";
setLocale(YupLocaleObject as LocaleObject);

export {}; // explicit module (no side-effect exports)
